import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { pathTo } from '../../../Routes';
import Logger from '../../../../../lib/Logger';
import LearningModuleStepViewHeader from './LearningModuleStepViewHeader';
import { Col, Row, Typography, Button } from 'antd';
import ComponentMedia from '../containers/ComponentMediaContainer';
import ReactQuill from 'react-quill';

const { Title } = Typography;

const modules = {
  toolbar: '#toolbar-read-only-module-step',
};

const LearningModuleStepView = ({
  activeId,
  moduleId,
  moduleStepId,
  load,
  learningModuleLearningStep,
  patch,
  ...props
}) => {
  useEffect(() => {
    load(activeId, moduleStepId);
  }, [activeId, moduleStepId, load]);

  useEffect(() => {
    if (learningModuleLearningStep?.id) {
      patch(activeId, learningModuleLearningStep.id, { is_updated: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [learningModuleLearningStep?.id]);

  const goToStep = (moduleStepId) => {
    props.history.push(
      pathTo('LearningModuleStepView', {
        id: activeId,
        moduleId,
        moduleStepId: moduleStepId,
      })
    );
  };

  const finishModuleStep = (moduleStepId) => {
    patch(activeId, moduleStepId, { is_completed: true }, (success) => {
      props.history.push(
        pathTo('LearningModuleStepsScreen', {
          id: activeId,
          moduleId,
        })
      );
    });
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div className='learning-module-learning-step-screen'>
            <LearningModuleStepViewHeader
              activeId={activeId}
              moduleId={moduleId}
              title={learningModuleLearningStep?.title}
              order={learningModuleLearningStep?.order}
            />

            <Row gutter={80}>
              <Col
                lg={{ span: 12, order: 1 }}
                md={{ span: 24, order: 1 }}
                sm={{ span: 24, order: 1 }}
                xs={{ span: 24, order: 1 }}
                style={{ marginBottom: '40px', width: '100%' }}
              >
                <div>
                  {learningModuleLearningStep && (
                    <ComponentMedia data={learningModuleLearningStep} />
                  )}
                </div>
              </Col>

              <Col
                lg={{ span: 12, order: 2 }}
                md={{ span: 24, order: 2 }}
                sm={{ span: 24, order: 2 }}
                xs={{ span: 24, order: 2 }}
                style={{ width: '100%' }}
              >
                <Title level={4} style={{ marginBottom: '20px' }}>
                  {learningModuleLearningStep?.subtitle}
                </Title>

                {learningModuleLearningStep &&
                  learningModuleLearningStep?.content && (
                    <div className='learning-module-learning-step-view-content'>
                      <div id='toolbar-read-only-module-step'></div>
                      <ReactQuill
                        modules={modules}
                        readOnly
                        value={learningModuleLearningStep?.content}
                      />
                    </div>
                  )}
                {(learningModuleLearningStep?.previous_step ||
                  learningModuleLearningStep?.next_step) && (
                  <div className='learning-module-learning-step-view-btns'>
                    {learningModuleLearningStep?.previous_step && (
                      <Button
                        onClick={() =>
                          goToStep(learningModuleLearningStep?.previous_step)
                        }
                        className='learning-module-learning-step-view-btn'
                      >
                        {t('learning_module_learning_step_view_button_back')}
                      </Button>
                    )}
                    {learningModuleLearningStep?.next_step ? (
                      <Button
                        type='primary'
                        className='learning-module-learning-step-view-btn'
                        onClick={() =>
                          goToStep(learningModuleLearningStep?.next_step)
                        }
                      >
                        {t('learning_module_learning_step_view_button_next')}
                      </Button>
                    ) : (
                      <Button
                        type='primary'
                        className='learning-module-learning-step-view-btn'
                        onClick={() =>
                          finishModuleStep(learningModuleLearningStep?.id)
                        }
                      >
                        {t('learning_module_learning_step_view_button_finish')}
                      </Button>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningModuleStepView);

Logger.log('silly', `LearningModuleStepView loaded.`);
